var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5505 35.9275H7.06638C5.32882 35.9275 3.88086 34.4796 3.88086 32.742V9.35739C3.88086 7.61983 5.03923 6.17188 6.55959 6.17188H8.15235V8.27142H6.55959C6.3424 8.27142 6.05281 8.70581 6.05281 9.35739V32.742C6.05281 33.3212 6.55959 33.828 7.13878 33.828H32.6229C33.2021 33.828 33.7089 33.3212 33.7089 32.742V9.35739C33.7089 8.70581 33.3469 8.27142 33.2021 8.27142H31.6094V6.17188H33.2021C34.6501 6.17188 35.8809 7.61983 35.8809 9.35739V32.742C35.7361 34.4796 34.2881 35.9275 32.5505 35.9275Z",
    fill: "#6FA34E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3376 10.4434C10.7584 10.4434 10.2516 9.93665 10.2516 9.35746V5.08597C10.2516 4.50679 10.7584 4 11.3376 4C11.9167 4 12.4235 4.50679 12.4235 5.08597V9.35746C12.3511 9.93665 11.9167 10.4434 11.3376 10.4434Z",
    fill: "#6FA34E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2795 10.4434C27.7003 10.4434 27.1935 9.93665 27.1935 9.35746V5.08597C27.1935 4.50679 27.7003 4 28.2795 4C28.8586 4 29.3654 4.50679 29.3654 5.08597V9.35746C29.3654 9.93665 28.8586 10.4434 28.2795 10.4434Z",
    fill: "#6FA34E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5237 6.17188H25.0938V8.34382H14.5237V6.17188Z",
    fill: "#6FA34E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98022 12.543H33.6363V14.7149H5.98022V12.543Z",
    fill: "#6FA34E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3655 16.8145H31.465V18.914H29.3655V16.8145Z",
    fill: "#6FA34E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0931 16.8145H27.2651V18.914H25.0931V16.8145Z",
    fill: "#6FA34E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8944 16.8145H22.994V18.914H20.8944V16.8145Z",
    fill: "#6FA34E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 16.8145H18.7227V18.914H16.6232V16.8145Z",
    fill: "#6FA34E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3518 16.8145H14.5238V18.914H12.3518V16.8145Z",
    fill: "#6FA34E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3655 21.0859H31.465V23.1855H29.3655V21.0859Z",
    fill: "#6FA34E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0931 21.0859H27.2651V23.1855H25.0931V21.0859Z",
    fill: "#6FA34E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8944 21.0859H22.994V23.1855H20.8944V21.0859Z",
    fill: "#6FA34E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 21.0859H18.7227V23.1855H16.6232V21.0859Z",
    fill: "#6FA34E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3518 21.0859H14.5238V23.1855H12.3518V21.0859Z",
    fill: "#6FA34E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1521 21.0859H10.2516V23.1855H8.1521V21.0859Z",
    fill: "#6FA34E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3655 25.2852H31.465V27.4571H29.3655V25.2852Z",
    fill: "#6FA34E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0931 25.2852H27.2651V27.4571H25.0931V25.2852Z",
    fill: "#6FA34E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8944 25.2852H22.994V27.4571H20.8944V25.2852Z",
    fill: "#6FA34E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 25.2852H18.7227V27.4571H16.6232V25.2852Z",
    fill: "#6FA34E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3518 25.2852H14.5238V27.4571H12.3518V25.2852Z",
    fill: "#6FA34E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1521 25.2852H10.2516V27.4571H8.1521V25.2852Z",
    fill: "#6FA34E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0931 29.5566H27.2651V31.6562H25.0931V29.5566Z",
    fill: "#6FA34E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8944 29.5566H22.994V31.6562H20.8944V29.5566Z",
    fill: "#6FA34E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6232 29.5566H18.7227V31.6562H16.6232V29.5566Z",
    fill: "#6FA34E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3518 29.5566H14.5238V31.6562H12.3518V29.5566Z",
    fill: "#6FA34E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1521 29.5566H10.2516V31.6562H8.1521V29.5566Z",
    fill: "#6FA34E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduler);
export default __webpack_public_path__ + "static/media/Scheduler.38d0ffd4faff6d38c091de70b036b795.svg";
export { ForwardRef as ReactComponent };